import { render, staticRenderFns } from "./ServiceTasks.vue?vue&type=template&id=7fd27c0c&"
import script from "./ServiceTasks.vue?vue&type=script&lang=js&"
export * from "./ServiceTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports